import React from "react";
import styles from "./contactBlock.module.css";
import { Section, SectionIntro } from "../UI";
import USAMap from "../MAP";

// Dark contact section that hosts one of the existing KUR forms.
const ContactBlock = ({ id = "contact", eyebrow, title, lead, points = [], note, details = [], showMap = false, children }) => (
  <Section tone="ink" id={id} labelledBy={`${id}-title`} className={styles.section}>
    <div className={styles.layout}>
      <div className={styles.intro}>
        <SectionIntro id={`${id}-title`} eyebrow={eyebrow} title={title} lead={lead} />
        {points.length > 0 && (
          <ul className={styles.points}>
            {points.map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
        )}
        <dl className={styles.direct}>
          <div>
            <dt>Call</dt>
            <dd>
              <a href="tel:+18663005380">(866) 300-5380</a>
            </dd>
          </div>
          <div>
            <dt>Email</dt>
            <dd>
              <a href="mailto:info@kurr.com">info@kurr.com</a>
            </dd>
          </div>
          {details.map((d) => (
            <div key={d.label}>
              <dt>{d.label}</dt>
              <dd>{d.href ? <a href={d.href}>{d.value}</a> : d.value}</dd>
            </div>
          ))}
        </dl>
        {note && <p className={styles.note}>{note}</p>}
      </div>
      <div className={styles.form}>{children}</div>
    </div>
    {showMap && (
      <div className={styles.map}>
        <USAMap />
      </div>
    )}
  </Section>
);

export default ContactBlock;
